/** @file imageOfSlot: the image id filling a slot of the puppet, or null when the slot is empty or unknown. */
import { parseSlotKey } from '@zilo/pose3d-format/derive/parseSlotKey';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** `facets[entry].slots[tile]` of the impostor the key names; null for a malformed key, an empty or unknown slot. */
export function imageOfSlot(puppet: Puppet, key: string): string | null {
  const k = parseSlotKey(key);
  const d = k === null ? undefined : puppet.drawables.find((x) => x.id === k.drawable);
  if (k === null || d?.kind !== 'impostor') return null;
  const slots = d.facets[k.entry]?.slots ?? {};
  return Object.hasOwn(slots, String(k.tile)) ? (slots[String(k.tile)] ?? null) : null;
}
